import { SECONDARY_LEVEL_NAV_OPTIONS, TOP_LEVEL_NAV_OPTIONS } from '@/constants/nav';

export function buildGuidesAgentToolkitChild ({ hasPendoForAgentsNav, t, hasAgentToolkitRedirect }) {
    if (hasPendoForAgentsNav) return [];

    return [{
        name: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        title: t('sideNav.guides.Agent Toolkit'),
        route: { name: 'AgentToolkit' },
        pendoAnalytics: 'agent-toolkit',
        hasRedirect: () => hasAgentToolkitRedirect(),
        tag: {
            type: 'beta',
            size: 'small',
        },
    }];
}

export function buildPendoForAgentsNavItem ({ hasPendoForAgentsNav, t, hasAgentToolkitRedirect }) {
    if (!hasPendoForAgentsNav) return [];

    return [{
        name: TOP_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        title: t('sideNav.agentToolkit.Pendo for agents'),
        iconComponent: 'AgentToolkitNavIcon',
        suffixIcon: false,
        route: { name: 'AgentToolkit' },
        pendoAnalytics: 'agent-toolkit-nav-item',
        hasRedirect: () => hasAgentToolkitRedirect(),
    }];
}

export function resolveAgentToolkitActiveNavOption ({ hasPendoForAgentsNav }) {
    if (hasPendoForAgentsNav) {
        return { topOptionName: TOP_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT };
    }

    return {
        topOptionName: TOP_LEVEL_NAV_OPTIONS.GUIDES,
        secondaryOptionName: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
    };
}
